import React, { useState } from "react";
import "./AudioMessageContent.scss";
import { ReactComponent as DownloadIcon } from "images/download_for_offline-24px.svg";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import LazyLoad from "react-lazy-load";
import useMediaApi from "hooks/useMediaApi";
import { Spinner } from "react-bootstrap";

export default function AudioMessageContent(props) {
  const { message, highlighted, isTransferred } = props;
  const transferredClass = isTransferred & !highlighted ? "transferred" : "";
  const [isContentVisible, setContentVisible] = useState(false);
  const { mediaUrl, isLoading } = useMediaApi(
    message.fileUrl,
    message.channel,
    isContentVisible
  );

  return (
    <div
      className={`audio-msg-ctr ${transferredClass}`}
      data-testid="audio-message-content"
    >
      <LazyLoad
        placeholder="loading audio"
        offset={100}
        height={60}
        width={300}
        onContentVisible={() => setContentVisible(true)}
      >
        {isLoading ? (
          <Spinner animation="border" />
        ) : (
          <div className="audio-container">
            <AudioPlayer
              src={mediaUrl}
              hasDefaultKeyBindings={false}
              className={`audio-div ${transferredClass}`}
              showJumpControls={false}
              autoPlayAfterSrcChange={false}
              autoPlay={false}
              showFilledVolume={false}
            />
            <div className="download-image">
              <a href={mediaUrl} download>
                <DownloadIcon />
              </a>
            </div>
          </div>
        )}
      </LazyLoad>
    </div>
  );
}
